const rankingItems = [
  { rank: 1, title: '斗罗大陆', type: '国漫·玄幻', heat: '🔥 892万', trend: 'up', chapter: '389话' },
  { rank: 2, title: '海贼王', type: '日漫·冒险', heat: '🔥 1,256万', trend: 'up', chapter: '1120话' },
  { rank: 3, title: '鬼灭之刃', type: '日漫·热血', heat: '⭐ 987万', trend: 'stable', chapter: '205话·完' },
  { rank: 4, title: '我独自升级', type: '韩漫·战斗', heat: '📈 678万', trend: 'up', chapter: '179话·完' },
  { rank: 5, title: '完美世界', type: '国漫·玄幻', heat: '📈 765万', trend: 'up', chapter: '256话' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门排行榜</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            基于全网阅读数据和讨论热度的实时排名
          </p>
        </div>

        <div className="max-w-[700px] mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 px-4 md:px-6 py-4 hover:bg-background-100 rounded-xl transition-colors cursor-pointer group"
            >
              <div
                className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 font-heading text-lg ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                      ? 'bg-accent-500 text-background-50'
                      : item.rank === 3
                        ? 'bg-secondary-500 text-background-50'
                        : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="font-heading text-base text-foreground-950 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                </div>
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.type}</span>
              </div>

              <div className="text-right shrink-0">
                <div className="text-xs font-medium text-foreground-700 mb-0.5 whitespace-nowrap">{item.heat}</div>
                <span className="text-[11px] text-foreground-400 whitespace-nowrap">{item.chapter}</span>
              </div>

              <div className="w-5 h-5 flex items-center justify-center shrink-0">
                <i
                  className={`${
                    item.trend === 'up'
                      ? 'ri-arrow-up-line text-primary-500'
                      : 'ri-subtract-line text-foreground-400'
                  } text-sm`}
                ></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}